import Helper from 'beebee-helper/helpers/format-date';
import { inject as service } from '@ember/service';

/**
 * Override e-commerce di format-date, REATTIVO al cambio lingua a tab aperto.
 * Il condiviso usa il locale GLOBALE di moment e non ricalcola quando la lingua
 * cambia (mesi/giorni restavano nella lingua precedente finche' non si
 * ri-renderizzava). `intl.primaryLocale` (ember-intl v8) legge il `_locale`
 * TRACCIATO: consumandolo qui, l'autotracking fa ricalcolare il helper al cambio
 * lingua (a quel punto moment.locale e' gia' aggiornato in application.js) e
 * mesi/giorni si aggiornano live. NB: usare `primaryLocale`, non `intl.locale`
 * (getter di v1-compat che non consuma il tracciato -> nessun ricalcolo).
 */
export default class EcommerceFormatDate extends Helper {
  @service intl;

  compute(params, hash) {
    void this.intl.primaryLocale; // dipendenza tracciata: ricalcolo al cambio lingua
    return super.compute(params, hash);
  }
}
